import { featuredCategories } from '@/mocks/homeData';

export default function FeaturedCategories() {
  return (
    <section className="py-16 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            Featured <span className="text-primary-600">Spreadsheet Collections</span>
          </h2>
          <p className="text-foreground-600 max-w-xl mx-auto">
            Handpicked collections from the Basetao Spreadsheet, curated for every style and budget.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {featuredCategories.map((card) => (
            <a
              key={card.name}
              href={card.url}
              target="_blank"
              rel="noopener nofollow"
              className="group block rounded-2xl overflow-hidden bg-background-50 border border-background-200 hover:border-primary-300 transition-all duration-200 cursor-pointer"
            >
              <div className="relative w-full aspect-[4/3] overflow-hidden">
                <img
                  src={card.image}
                  alt={card.name}
                  className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent"></div>
              </div>
              <div className="p-5">
                <h3 className="font-heading font-semibold text-foreground-950 mb-2 group-hover:text-primary-600 transition-colors">
                  {card.name}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {card.description}
                </p>
                <span className="inline-flex items-center gap-1.5 mt-3 text-sm font-medium text-primary-600">
                  Explore Collection
                  <span className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-arrow-right-line text-sm"></i>
                  </span>
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}